import React from 'react';
import PropTypes from 'prop-types';

const Hamburger = ({ onClick }) => (
  <svg
    className="hamburger"
    onClick={onClick}
    width="28px"
    height="22px"
    viewBox="-4 -2 28 22"
  >
    <defs>
      <path
        d="M0,13 C0,12.4477153 0.455305576,12 0.99180311,12 L19.0081969,12 C19.5559546,12 20,12.4438648 20,13 C20,13.5522847 19.5446944,14 19.0081969,14 L0.99180311,14 C0.444045377,14 0,13.5561352 0,13 L0,13 L0,13 Z M0,1 C0,0.44771525 0.455305576,0 0.99180311,0 L19.0081969,0 C19.5559546,0 20,0.443864822 20,1 C20,1.55228475 19.5446944,2 19.0081969,2 L0.99180311,2 C0.444045377,2 0,1.55613518 0,1 L0,1 L0,1 Z M0,7 C0,6.44771525 0.455305576,6 0.99180311,6 L19.0081969,6 C19.5559546,6 20,6.44386482 20,7 C20,7.55228475 19.5446944,8 19.0081969,8 L0.99180311,8 C0.444045377,8 0,7.55613518 0,7 L0,7 L0,7 Z"
        id="hamburger-path-1"
      />
    </defs>
    <g id="hamburger-shape" stroke="none" fill="none">
      <use fillRule="evenodd" xlinkHref="#hamburger-path-1" />
    </g>
  </svg>
);

Hamburger.propTypes = {
  onClick: PropTypes.any,
};

export default Hamburger;
